<template>
	<v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot 
            title="3 STEPS SKILLS PATH"
            :length="0"
            btn_txt=""
            btn_to="" />

        <div class="d-flex justify-center mt-6" :class="($vuetify.breakpoint.smAndDown) ? 'flex-column' : ''" v-if="loaded">
            <v-card class="d-flex align-center px-4 white--text" color="primary" height="40px" @click="choosen='all'" :class="($vuetify.breakpoint.smAndDown) ? 'mb-2' : ' mr-3'">
                <v-icon small color="white" class="mr-3" v-if="choosen=='all'">fa-dot-circle</v-icon>
                <v-icon small color="white" class="mr-3" v-else>fa-circle</v-icon>
                <div class="body-2">All courses</div>
            </v-card>
            <div v-for="it in categories" :key="it.id" :class="($vuetify.breakpoint.smAndDown) ? 'mb-2' : ' mr-3'">
                <v-card class="d-flex align-center px-4 white--text" :color="it.color" height="40px" @click="choosen=it.short">
                    <v-icon small color="white" class="mr-3" v-if="choosen==it.short">fa-dot-circle</v-icon>
                    <v-icon small color="white" class="mr-3" v-else>fa-circle</v-icon>
                    <div class="body-2">{{it.title}}</div>
                </v-card>
            </div>
        </div>
        
        <v-row class="mt-6" v-if="loaded">
            <v-col cols="12" sm="4" md="3" v-if="choosen==item.short || choosen=='all'" v-for="item in courses" :key="item.id">
                <v-card class="mx-auto" width="250px" height="170px" hover :color="item.color" @click="$router.push('video-section/'+item.id)" >
                    <v-card-text class="white--text">
                        <div class="subtitle-1 font-weight-medium pa-2" style="line-height:1.1; background-color:rgba(0,0,0,.05); border-radius:4px">
                            {{item.title}}
                        </div>
                        <v-divider class="mt-2"></v-divider>
                        <div class="mt-2 body-2 font-weight-regular" style="line-height:1.3">{{item.subtitle}}</div>
                        <div class="d-flex align-center mt-2">
                            <v-icon size="11px" class="mr-2" color="white">fa-video</v-icon>
                            <div class="caption font-weight-regular">{{item.videos.length}} videos</div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <SendingLoader v-if="!loaded" />
	</v-card>
</template>

<script>
import _ from 'lodash'
import Helpers from '@/services/helpers'
import Videos from '@/firebase/videos'

export default {
    data: () => ({
        loaded: false,
        courses: [],
        categories: [],
        choosen: 'all'
    }),
    props: ['tab'],
    mounted() {
        this.init();
    },
    methods: {
        init() {
            Videos.getCoursesCategories()
                    .then(response => {
                        if (response.status === true) {
                            this.categories = Helpers.formatItems(response.query);
                            this.getCourses();
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        getCourses() {
            Videos.getCourses()
                    .then(response => {
                        if (response.status === true) {
                            this.courses = Helpers.formatItems(response.query);
                            this.setCategoryInfo();
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        setCategoryInfo() {
            this.courses.forEach(dt => {
                let tempo = this.categories.find(item => {return item.id == dt.category});
                dt.categoryTitle = tempo.title;
                dt.color = tempo.color;
                dt.short = tempo.short;
            });
        }
    }
}
</script>